import React from 'react';
import { useLocale } from '../../localization/LocaleContext';

export default function FAQ4(){
    const { t } = useLocale();
    return(
        <div className="question mt-40">
            <h4 className="h-4 h-bold">
                {t('faq.businessReports.heading')}
            </h4>
            <div className="questions">
                <h6 className="h-6 bold-500 text-left">
                    {t('faq.businessReports.q1')}
                </h6>
                <p className="paragraph p-adjustment text-left">
                    {t('faq.businessReports.a1')}
                </p>
                <h6 className="h-6 bold-500 text-left">
                    {t('faq.businessReports.q2')}
                </h6>
                <p className="paragraph p-adjustment text-left">
                    {t('faq.businessReports.a2')}
                </p>
            </div>
        </div>
    )
}